import log from 'loglevel';
import {caseDetails} from '../../App/App.config';
import {router} from '../../services';
import pushGTMEvent from '../../util/helper/pushGTMEvent';

const createCase = async (
  currentHULADetails,
  user,
  caseDescription,
  errorType,
  caseError,
  credentials,
) => {
  let errorDesc;
  let errorMessage;
  let product;
  let release;
  let productKey;
  let currentProductYear;
  let requestedProductYear;
  let requestedVersion;
  if(caseError.errorDesc === '' || caseError.errorMessage !== '') {
    errorDesc = caseError.errorDesc;
    errorMessage = caseError.errorMessage;
  }

  const { selectedProductVersion  } = currentHULADetails;
  if(selectedProductVersion !== null && selectedProductVersion !== undefined && selectedProductVersion !== ''){
    product = selectedProductVersion.slice(0, selectedProductVersion.length - 5) // return product
    release = selectedProductVersion.slice(product.length + 1, selectedProductVersion.length) // return year
  }

  if(currentHULADetails.colName === null && currentHULADetails.productKey) {
    productKey = currentHULADetails.productKey;
  }else if(currentHULADetails.datalist.length === 0 && currentHULADetails.productKeyMapping){
    const { productKeyMapping } = currentHULADetails;
    if(productKeyMapping.length > 0) {
      productKeyMapping.forEach(data => {
        let { productLineName } = data;
        productLineName = productLineName.replace('Autodesk ', '');
        if(productLineName === product && data.release === release) {
          productKey = data.productKey;
        }
      })
    }
  } else if(Object.keys(currentHULADetails.productVersionKeys).length !== 0){
    // e.g. "Advance Steel 2019" -> "Advance Steel_2019"
    productKey = currentHULADetails.productVersionKeys.productKey[release];
  } else {
    // e.g. "Advance Steel 2019" -> "Advance Steel_2019"
    productKey = currentHULADetails.productKey;
  }

  if(currentHULADetails.selectedProductVersion && currentHULADetails.selectedProductVersion !== null){
    currentProductYear = currentHULADetails.selectedProductVersion;
    requestedProductYear = currentHULADetails.selectedProductVersion.slice(-4);
    requestedVersion = currentHULADetails.selectedProductVersion.slice(-4);
  }

  let payload = {
    fName: user.firstName,
    lName: user.lastName,
    Email: user.email,
    CurrentProductYear: currentProductYear,
    RequestedProductYear: requestedProductYear,
    requestedVersion,
    RequestorEmail: user.email,
    Description: `
      Serial Number: ${currentHULADetails.serialNumber}\n
      Product: ${product}(${productKey})\n
      Previous version requested:: ${currentHULADetails.selectedProductVersion}
      Error: ${errorMessage}\n
      Customer comments: ${caseDescription},
      APIGEE Code: ${errorType}
      ErrorMessage: ${errorDesc}`,
  };

  payload = { ...payload, ...caseDetails };
  if(productKey !== null && productKey !== ''){
    payload.productKey = productKey;
  }
  try {
    const caseResponse = await router(
      'CASE',
      payload,
      credentials,
    );
    return caseResponse;
  } catch (err) {
    log.error(err);
  }
  return null;
};

const asyncCaseCall = async (
  currentHULADetails,
  dispatch,
  user,
  caseDescription,
  errorType,
  caseError,
  credentials,
  ) => {
  dispatch({ type: 'GO_TO_SPIN_PAGE' });
  try {
    const { data, status } = await createCase(
      currentHULADetails,
      user,
      caseDescription,
      errorType,
      caseError,
      credentials,
    );
    if (data && data.caseNumber && status === 200) {
      pushGTMEvent('CreateCase/Success');
      dispatch({
        type: 'GO_TO_CREAT_CASE_SUCCESS_PAGE',
        payload: { caseNumber: data.caseNumber },
      });
    } else {
      pushGTMEvent('CreateCase/Error');
      dispatch({
        type: 'GO_TO_ERROR_PAGE',
        payload: 'apigeeError',
      });
    }

    } catch (e) {
    pushGTMEvent('CreateCase/Error');
    dispatch({
      type: 'GO_TO_ERROR_PAGE',
      payload: 'apigeeError',
    });
  }
}

export default asyncCaseCall;
